import axios from 'axios';

const BASE_URL = '/app/websiteTriggerFunnel';

export const saveConfig = async (body) => {
    const { data } = await axios.post(`${BASE_URL}/save`, body);

    return data;
};

export const triggerCodeAndUrls = async (funnelId, goalId) => {
    const {
        data: {
            trackingCode, urls, message, success,
        },
    } = await axios.get(`${BASE_URL}/websiteTriggerCodeAndUrls/${funnelId}/${goalId}`);

    return {
        trackingCode, urls, message, success,
    };
};
